export interface BasePcList {
  id: string; // 标识 id
  name: string; // 路由 name
  path: string; // 路由 path
  link?: string; // 下载链接
  filename?: string; // 自定义文件名称
  isBaiduApiToken?: string; // 需要百度上报apitoken拼接
  styleType: number; // 页面样式类型

}

export const basePcList: BasePcList[] = [
  {
    id: "10001",
    name: "swbd2",
    path: "/swbd2",
    filename: "996boxV360SetupSigned@6102.exe",
    link: "//static.dhsf.996box.com/box/channel_app/996boxV360SetupSigned@6102.exe",
    isBaiduApiToken:
      "2du5kihwl29kY7qU8jE9wdmM5jrpz2YC@njw0ZjB6D9ZSbFN4px1YvYwCOti3y4lC",
    styleType: 1,
  },
  {
    id: "10002",
    name: "fsbd5",
    path: "/fsbd5",
    filename: "996box420SetupSigned@6138.exe",
    link: "//static.dhsf.996box.com/box/channel_app/996box420SetupSigned@6138.exe",
    isBaiduApiToken:
      "djlgz6eeV7rI9b95u4QEC1sQTZg9HBYm@xdmztMN4ckLPfSbsO6vKQHfpd4YaKzf7",
      styleType: 2,
  },
];
